import { render, staticRenderFns } from "./CreateCatalogSet.vue?vue&type=template&id=c9fc17b0"
import script from "./CreateCatalogSet.vue?vue&type=script&lang=js"
export * from "./CreateCatalogSet.vue?vue&type=script&lang=js"
import style0 from "./CreateCatalogSet.vue?vue&type=style&index=0&id=c9fc17b0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports